import React, { useState, useEffect, useRef, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUser } from "../../service/user"
import { updateFcmToken } from "../../service/user";
import { getWebinarByAccount } from "../../service/webinarService";
import { getCampaignByAccountId, createCampaignUser, getCampaignUserScores, createCampaignUserScore } from "../../service/campaignService";
import { trackCTA } from "../../service/usercta";
import { useAuth } from "../../context/AuthContext";
import { usePageTracking } from '../../service/usercta';
import axios from "axios";
import Campaign from "./Campaign";
import { PodcastProvider, usePodcast } from '../../context/PodcastContext';
import PodcastDialog from './PodcastDialog';
import WellnessCampaign from './Wellnesscampaign';


// Function to get the next weekday (skips weekends)
// const getNextWeekday = () => {
//     const today = new Date();
//     const daysToAdd = today.getDay() >= 5 ?
//         (8 - today.getDay()) : // If it's Friday or later, go to next Monday
//         (today.getDay() === 0 ? 1 : 1); // If it's Sunday, go to Monday, otherwise next day

//     const nextDay = new Date(today);
//     nextDay.setDate(today.getDate() + daysToAdd);

//     // Format: Day, Month Date (e.g., "Monday, Sep 15")
//     const options = { weekday: 'long', month: 'short', day: 'numeric' };
//     return {
//         date: nextDay.toLocaleDateString('en-US', options),
//         time: '7:30 AM',
//         duration: '30 min',
//         isWeekend: nextDay.getDay() === 0 || nextDay.getDay() === 6
//     };
// };

const getTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const options = { weekday: 'long', month: 'short', day: 'numeric' };
    return {
        date: tomorrow.toLocaleDateString('en-US', options),
        time: '7:30 AM',
        duration: '30 min',
        isWeekend: [0, 6].includes(tomorrow.getDay())
    };
};

import {
    Box,
    useMediaQuery,
    useTheme,
    Typography,
    Dialog,
    DialogContent,
    Chip,
    Card,
    CardContent,
    Button,
    Divider,
    DialogTitle,
    IconButton,
    Slider,
    DialogContentText,
    DialogActions,
    Paper,
    TextField,
    Avatar,
    LinearProgress,
    Fade
} from '@mui/material';
import { Pause, PlayArrow, VolumeUp, VolumeOff, Close, ScreenRotation, BatteryAlert, BatteryFull, Battery80, Battery60, Battery20, Battery0Bar, HealthAndSafety, Psychology, Accessibility, Favorite, DirectionsWalk, People, Spa, MusicNote, SelfImprovement, EmojiEvents } from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WebIcon from '@mui/icons-material/Web';
import PsychologyIcon from '@mui/icons-material/Psychology';
import CloseIcon from '@mui/icons-material/Close';
import SpaIcon from '@mui/icons-material/Spa';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import InsightsIcon from '@mui/icons-material/Insights';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import Tooltip from '@mui/material/Tooltip';
import ConsultantIcon from '../../assets/Consultant.svg';
import careIcon from '../../assets/care.svg';
import cultivateIcon from '../../assets/cultivate.svg';
import WelcomeMessage from '../../components/WelcomeMessage';
import QuickActions from './QuickActions';
import EventModal from '../../components/EventModal';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { getCurrentUser } from '../../utils/auth';
import ReactPlayer from 'react-player';
import TermsAndConditions from './YogaTermsAndCondition';

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { checkEnrollmentStatus, getPodcastForToday, getYogaVideoForToday } from '../../service/home';
import SmartBiometricTherapyDialog from './SmartBiometricTherapyDialog';
import SelfCareCampaign from './Selfcarecampaign';

// Function to check if device is mobile - 11 nov
const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};


const MoodDisplay = () => {
    const [todayMood, setTodayMood] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Check for today's mood
        const moodData = JSON.parse(localStorage.getItem('echobuddy_mood_data') || '[]');
        const today = new Date().toISOString().split('T')[0];
        const todayEntry = moodData.find(entry => entry.date === today);

        if (todayEntry) {
            setTodayMood(todayEntry.mood);
        }
    }, []);

    if (!todayMood) return null;

    // Mood colors based on mood type
    const moodColors = {
        'Miserable': '#ef4444',
        'Horrible': '#f97316',
        'Frustrating': '#f59e0b',
        'Sad': '#fbbf24',
        'Indifferent': '#a3a3a3',
        'Neutral': '#94a3b8',
        'Happy': '#22c55e',
        'Delightful': '#10b981',
        'Blissful': '#06b6d4',
        'Exuberant': '#3b82f6'
    };

    const moodEmojis = {
        'Miserable': '😭',
        'Horrible': '😢',
        'Frustrating': '😠',
        'Sad': '😔',
        'Indifferent': '😐',
        'Neutral': '😌',
        'Happy': '😊',
        'Delightful': '😄',
        'Blissful': '😇',
        'Exuberant': '🤩'
    };





    return (
        // <Card sx={{
        //     mb: 2,
        //     p: 2,
        //     borderRadius: 3,
        //     background: `linear-gradient(135deg, ${moodColors[todayMood]}20 0%, ${moodColors[todayMood]}10 100%)`,
        //     border: `1px solid ${moodColors[todayMood]}30`
        // }}>
        //     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        //         <Box>
        //             <Typography variant="subtitle2" sx={{ color: moodColors[todayMood], fontWeight: 600, mb: 0.5 }}>
        //                 Today's Mood
        //             </Typography>
        //             <Typography variant="h6" sx={{ color: moodColors[todayMood], fontWeight: 700 }}>
        //                 {todayMood} {moodEmojis[todayMood]}
        //             </Typography>
        //         </Box>
        //         <Button
        //             variant="outlined"
        //             size="small"
        //             onClick={() => navigate('/mood-checkin')}
        //             sx={{
        //                 borderColor: moodColors[todayMood],
        //                 color: moodColors[todayMood],
        //                 '&:hover': {
        //                     backgroundColor: `${moodColors[todayMood]}10`,
        //                     borderColor: moodColors[todayMood]
        //                 }
        //             }}
        //         >
        //             Update
        //         </Button>
        //     </Box>
        // </Card>
        <Box
            sx={{
                mb: 1.5,
                p: 2,
                borderRadius: 3,
                backdropFilter: 'blur(8px)',
                background: `linear-gradient(135deg, #f9f9f912 0%, #f9f9f905 100%)`,
                border: '2px solid #e0e0e0', // light gray border
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', // ✅ soft light shadow
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                    border: '2px solid #bdbdbd', // slightly darker on hover
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)' // ✅ deeper shadow on hover
                }
            }}
        >
            <Box>
                {/* Top Row: Title + Button */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 0.4
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: moodColors[todayMood],
                            letterSpacing: 0.2,
                            fontWeight: 600,
                            fontSize: { xs: '15px', sm: '16px' }
                        }}
                    >
                        Today's Mood
                    </Typography>

                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => navigate('/mood-checkin')}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                            borderRadius: 1.5,
                            px: 1.5,
                            py: 0.3,
                            minWidth: 'auto',
                            backgroundColor: `${moodColors[todayMood]}25`,
                            color: moodColors[todayMood],
                            border: `1px solid ${moodColors[todayMood]}35`,
                            backdropFilter: 'blur(5px)',
                            transition: 'all 0.25s ease-in-out',
                            '&:hover': {
                                backgroundColor: `${moodColors[todayMood]}40`,
                                boxShadow: `0 0 8px ${moodColors[todayMood]}40`,
                                transform: 'scale(1.04)'
                            }
                        }}
                    >
                        Update
                    </Button>
                </Box>

                {/* Bottom Row: Mood */}
                <Typography
                    variant="body2"
                    sx={{
                        color: '#64748B',
                        fontSize: { xs: '13.5px', sm: '15px' },
                        fontWeight: 500,
                        lineHeight: 1.5,
                        letterSpacing: '0.01em'
                    }}
                >
                    {moodEmojis[todayMood?.label]} {todayMood?.label}
                    {moodEmojis[todayMood?.emoji]} {todayMood?.emoji}
                </Typography>
            </Box>
        </Box>

    );
};

// Weekly pregnancy content mapping 

const weeklyContent = {
    1: {
        description: "Supporting you through every stage of pregnancy with mindful movement and small practices that care for both your body and your emotional wellbeing.",
        videoUrl: "https://www.youtube.com/embed/1UH9B0FsD_Q"
    },
    2: {
        description: "Supporting you through the first trimester of your pregnancy with mindful movement and small practices that care for both your body and your emotional wellbeing.",
        videoUrl: "https://www.youtube.com/embed/uQw39892y7E"
    },
    3: {
        description: "Two mothers come to share their personal experiences, reflections, and journeys through pregnancy and motherhood, creating space for honesty, connection, and support.",
        videoUrl: "https://www.youtube.com/embed/uQw39892y7E"
    },
    4: {
        description: "A conversation around endometriosis, understanding its impact, recognising the signs, and creating more awareness around women's physical and emotional wellbeing.",
        videoUrl: "https://www.youtube.com/embed/uQw39892y7E"
    }
};

// Keep backward compatibility for existing code
const weeklyVideos = {
    1: weeklyContent[1].videoUrl,
    2: weeklyContent[2].videoUrl,
    3: weeklyContent[3].videoUrl,
    4: weeklyContent[4].videoUrl,
};

const PodcastListenButton = ({ sx }) => {
    const { handleListenNow } = usePodcast();
    return (
        <Button variant="contained" size="small" onClick={handleListenNow} sx={sx}>
            Listen Now
        </Button>
    );
};

const Home = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [open, setOpen] = useState(false);
    const phoneNumber = "9999666555";
    const [eventModalOpen, setEventModalOpen] = useState(false);
    const [isTermsOpen, setIsTermsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isYogaVideoOpen, setIsYogaVideoOpen] = useState(false);
    const [scheduledVideo, setScheduledVideo] = useState(null);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [isWebinarRegistered, setIsWebinarRegistered] = useState(false);
    const [isMomModalOpen, setIsMomModalOpen] = useState(false);
    const [playerReady, setPlayerReady] = useState(false);
    const [isInsightsComingSoonOpen, setIsInsightsComingSoonOpen] = useState(false);
    const videoRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [volume, setVolume] = useState(0.7);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const videoContainerRef = useRef(null);
    const containerRef = useRef(null);
    const [isLandscape, setIsLandscape] = useState(false);
    const [muted, setMuted] = useState(true);
    const [webinarData, setWebinarData] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentUser, setCurrentUser] = useState(getCurrentUser());
    const [campaignModalOpen, setCampaignModalOpen] = useState(false);
    const [currentDay, setCurrentDay] = useState(1);

    // Get current week based on actual day of the month
    // For testing: Set localStorage.setItem('testWeek', '1-4') to override
    const testWeek = localStorage.getItem('testWeek');
    const currentWeek = testWeek ? parseInt(testWeek) : Math.min(4, Math.ceil(new Date().getDate() / 7));
    const videoUrl = weeklyVideos[currentWeek];
    const [dailyAnswer, setDailyAnswer] = useState('');
    const [campaignProgress, setCampaignProgress] = useState({});
    const [showSubmissionSuccess, setShowSubmissionSuccess] = useState(false);
    const [campaignData, setCampaignData] = useState(null);
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [userCampaignScores, setUserCampaignScores] = useState([]);
    const [campaignUserData, setCampaignUserData] = useState(null);
    usePageTracking();
    const accountId = localStorage.getItem('account_id');
    const user_id = localStorage.getItem('user_id');

    // const handleListenNow = async () => {
    //     try {
    //         const data = await getPodcastForToday();
    //         setPodcast(data);

    //         handleEventAction('podcast'); // keep your existing logic
    //     } catch (err) {
    //         console.log("Failed to load podcast");
    //     }
    // };



    const handleOpenMomModal = () => {
        setPlayerReady(false);
        setIsMomModalOpen(true);

        setTimeout(() => setPlayerReady(true), 350);
    };

    const handleCloseMomModal = () => {
        setIsMomModalOpen(false);
        setPlayerReady(false);       // destroy iframe cleanly
    };

    // webinar useeffect
    useEffect(() => {
        const fetchWebinar = async () => {
            const accountId = localStorage.getItem('account_id');
            if (accountId) {
                try {
                    const response = await getWebinarByAccount(accountId);

                    // The response is already the array of webinars, so take the first one
                    const firstWebinar = response?.[0] || null;
                    setWebinarData(firstWebinar);
                } catch (error) {
                    console.error('Error fetching webinar:', error);
                    setWebinarData(null);
                }
            }
        };

        fetchWebinar();
    }, []);

    // campaign useeffect
    useEffect(() => {
        const fetchCampaign = async () => {
            const accountId = localStorage.getItem('account_id');
            if (!accountId) return;

            try {
                const result = await getCampaignByAccountId(accountId);
                if (result.success) {
                    if (result.data && (result.data.msg === 'no campaign found' || result.data.message === 'no campaign found')) {
                        setCampaignData(null);
                    } else {
                        setCampaignData(result.data);
                        // Set current day from API response
                        if (result.data.campaign_day > 0) {
                            setCurrentDay(result.data.campaign_day);
                            setIsEnrolled(true);
                            await fetchCampaignUserData(result.data.id);
                            await fetchUserScores(parseInt(user_id), result.data.id);
                        } else {
                            setCurrentDay(1);
                            setIsEnrolled(false);
                        }
                    }
                } else {
                    console.error('Error fetching campaign:', result.error);
                    setCampaignData(null);
                }
            } catch (error) {
                console.error('Error fetching campaign:', error);
                setCampaignData(null);
            }
        };

        fetchCampaign();
    }, []);

    // Check if user is enrolled in campaign
    // const checkEnrollment = async (campaignId) => {
    //     console.log("📌 campaignId:", campaignId);
    //     console.log("📌 user_id:", user_id);

    //     // 🔥 STRICT CHECK
    //     if (campaignId === undefined || campaignId === null || !user_id) {
    //         console.warn("❌ Missing campaignId or user_id");
    //         return;
    //     }

    //     try {
    //         const result = await getCampaignUsers(user_id, campaignId);

    //         console.log("📌 API RESULT:", result);

    //         // ✅ Check if backend returned data object
    //         const isUserEnrolled = !!result?.data?.data;

    //         console.log("✅ isUserEnrolled:", isUserEnrolled);

    //         setIsEnrolled(isUserEnrolled);

    //         if (isUserEnrolled) {
    //             await fetchCampaignUserData(campaignId);
    //             await fetchUserScores(parseInt(user_id), campaignId);
    //         }

    //     } catch (error) {
    //         console.error('❌ Error checking enrollment:', error);
    //     }
    // };

    // Fetch user's campaign scores
    const fetchUserScores = async (userId, campaignId) => {
        try {
            const result = await getCampaignUserScores(userId, campaignId);
            if (result.success && result.data) {
                setUserCampaignScores(result.data);
            }
        } catch (error) {
            console.error('Error fetching user scores:', error);
        }
    };

    // Fetch campaign user data
    const fetchCampaignUserData = async (campaignId) => {
        try {
            const result = await getCampaignUsers(user_id);
            if (result.success && result.data && result.data.length > 0) {
                const accountId = localStorage.getItem('account_id');
                const userData = result.data.find(u => u.id === parseInt(accountId));
                if (userData) {
                    setCampaignUserData(userData);
                }
            }
        } catch (error) {
            console.error('Error fetching campaign user data:', error);
        }
    };

    // Determine which day to show based on user's progress
    const determineCurrentDay = (scores) => {
        if (!campaignUserData?.start_date || !campaignData?.start_date) {
            setCurrentDay(1);
            return;
        }

        const campaignStartDate = new Date(campaignData.start_date);
        const userStartDate = new Date(campaignUserData.start_date);

        // Remove time portion to avoid timezone issues
        campaignStartDate.setHours(0, 0, 0, 0);
        userStartDate.setHours(0, 0, 0, 0);

        // Calculate offset (user start - campaign start)
        const offset = Math.floor((userStartDate - campaignStartDate) / (1000 * 60 * 60 * 24));

        // User's day is the offset
        const userDay = offset;


        // Don't allow showing beyond campaign duration
        const maxDay = campaignData?.duration || userDay;
        const currentDay = Math.min(
            userDay > 0 ? userDay : 1,
            maxDay
        );

        setCurrentDay(currentDay);
    };

    // Check if a day is completed
    const isDayCompleted = (dayNumber) => {
        if (!userCampaignScores || userCampaignScores.length === 0) {
            return false;
        }
        return userCampaignScores.some(score => score.day_number === dayNumber);
    };

    // Get answer for a specific day
    const getDayAnswer = (dayNumber) => {
        if (!userCampaignScores || userCampaignScores.length === 0) {
            return null;
        }
        const score = userCampaignScores.find(s => s.day_number === dayNumber);
        return score ? score.answer : null;
    };

    // Get the most recent submitted response
    const getLastResponse = () => {
        if (!userCampaignScores || userCampaignScores.length === 0) {
            return null;
        }
        // Sort by day_number descending to get the most recent
        const sortedScores = [...userCampaignScores].sort((a, b) => b.day_number - a.day_number);
        return sortedScores[0];
    };

    // Handle Count Me In - Check if user exists in DB, if not create
    const handleCountMeIn = async () => {
        if (!campaignData) {
            console.error('Campaign data not available');
            return;
        }

        if (!accountId) {
            console.error('Account ID not found');
            return;
        }

        try {
            console.log('Checking if user exists for campaign:', user_id);

            // const usersResult = await (user_id);
            // console.log('Campaign users result:', usersResult);

            // ✅ FIXED: correct data extraction
            // const users = usersResult?.data?.data || [];

            // const existingUser = users.find(
            //     u => u.user_id === parseInt(user_id)
            // );

            // if (existingUser) {
            //     console.log('User already enrolled:', existingUser);
            //     setCampaignUserData(existingUser);
            //     setIsEnrolled(true);

            //     await fetchUserScores(parseInt(user_id), campaignData.id);
            //     handleEventAction('campaign');
            //     return;
            // }

            // ✅ Create new user
            const today = new Date().toISOString();

            const campaignUserData = {
                user_id: Number(user_id),   // ✅ FIXED
                campaign_id: campaignData.id,
                start_date: today
            };

            console.log('Creating campaign user with data:', campaignUserData);

            const result = await createCampaignUser(campaignUserData);
            console.log('Create campaign user result:', result);

            if (result.success) {
                setIsEnrolled(true);
                setCurrentDay(1);
                handleEventAction('campaign');
            } else {
                console.error('Error creating campaign user:', result.error);
                alert('Failed to enroll in campaign: ' + result.error);
            }

        } catch (error) {
            console.error('Error creating campaign user:', error);
            alert('Something went wrong. Please try again.');
        }
    };

    // Handle Continue - For already enrolled users
    const handleContinue = async () => {
        if (!campaignData) return;

        const accountId = localStorage.getItem('account_id');
        if (!accountId) return;

        try {
            // Fetch campaign user data to get user's start date
            await fetchCampaignUserData(campaignData.id);
            // Fetch latest scores to determine current day
            await fetchUserScores(parseInt(user_id), campaignData.id);
            // Open the campaign modal
            handleEventAction('campaign');
        } catch (error) {
            console.error('Error in handleContinue:', error);
        }
    };


    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
            setMuted(videoRef.current.muted);
        }
    };

    // useEffect(() => {
    //     // Create global function so Flutter can call it
    //     window.receiveDataFromApp = ({ token, userId, email }) => {
    //         console.log("🔥 Data received from Flutter:", { token, userId, email });

    //         // Store data in localStorage
    //         localStorage.setItem("firebaseToken", token);
    //         localStorage.setItem("userId", userId);
    //         localStorage.setItem("email", email);

    //         // Show alert
    //         alert(`Firebase Token: ${token}\nUser ID: ${userId}\nEmail: ${email}`);
    //     };
    // }, []);



    // useEffect(() => {
    //     window.showAlert = function () {
    //         alert('Hello from React');
    //     };

    //     return () => {
    //         delete window.showAlert;
    //     };
    // }, []);


    //    25 nov
    // useEffect(() => {
    //     // Create global function so Flutter can call it
    //     window.receiveDataFromApp = async ({ token, userId, email }) => {
    //         console.log("🔥 Data received from Flutter:", { token, userId, email });

    //         alert(
    //             `✅ Firebase Token Saved!
    //             Token: ${token}
    //             User ID: ${userId}
    //             Message: ${result?.message || "Success"}`
    //         );

    //         // Store data in localStorage
    //         localStorage.setItem("firebaseToken", token);
    //         localStorage.setItem("userId", userId);
    //         localStorage.setItem("email", email);

    //         // Call backend to save FCM token
    //         try {
    //             const result = await updateFcmToken(userId, token);
    //             console.log("📡 Backend Response:", result);

    //             console.log(`Firebase Token Saved!\nToken: ${token}\nUser ID: ${userId}\nMessage: ${result.message}`)
    //             // alert(
    //             //     `Firebase Token Saved!\nToken: ${token}\nUser ID: ${userId}\nMessage: ${result.message}`
    //             // );
    //         } catch (err) {
    //             console.error("❌ Error updating FCM token:", err);
    //             alert(`Failed to save FCM token to backend.\n${err.message}`);
    //         }
    //     };
    // }, []);



    //12 nov 
    // const handleFullscreenToggle = async () => {
    //     if (!containerRef.current) return; // Changed from videoRef.current to containerRef.current
    //     console.log('Toggling fullscreen. Current state:', isFullscreen);
    //     try {
    //         if (document.fullscreenElement || document.webkitFullscreenElement) {
    //             // Exit fullscreen
    //             if (document.exitFullscreen) {
    //                 await document.exitFullscreen();
    //             } else if (document.webkitExitFullscreen) {
    //                 await document.webkitExitFullscreen();
    //             }
    //             setIsFullscreen(false);
    //         } else {
    //             // Enter fullscreen on the container (which includes video + buttons)
    //             const element = containerRef.current; // Changed from videoRef.current to containerRef.current
    //             if (element.requestFullscreen) {
    //                 await element.requestFullscreen();
    //             } else if (element.webkitRequestFullscreen) {
    //                 await element.webkitRequestFullscreen();
    //             }
    //             setIsFullscreen(true);
    //         }
    //     } catch (err) {
    //         console.error('Fullscreen error:', err);
    //     }
    // };

    // const handleFullscreenToggle = async () => {
    //     if (!containerRef.current) return;

    //     try {
    //         if (document.fullscreenElement || document.webkitFullscreenElement) {
    //             await handleFullscreenExit();  // <-- call it here
    //         } else {
    //             const element = containerRef.current;
    //             if (element.requestFullscreen) await element.requestFullscreen();
    //             else if (element.webkitRequestFullscreen) await element.webkitRequestFullscreen();

    //             setIsFullscreen(true);

    //             // Lock landscape on mobile
    //             if (isMobileDevice() && screen.orientation?.lock) {
    //                 await screen.orientation.lock('landscape');
    //             }
    //         }
    //     } catch (err) {
    //         console.error('Fullscreen error:', err);
    //     }
    // };

    const handleFullscreenToggle = async () => {
        if (!containerRef.current) return;

        try {
            if (document.fullscreenElement || document.webkitFullscreenElement) {
                await handleFullscreenExit();  // exit logic already handles state
            } else {
                const element = containerRef.current;

                // Optimistically set state before async operations
                setIsFullscreen(true);

                if (element.requestFullscreen) await element.requestFullscreen();
                else if (element.webkitRequestFullscreen) await element.webkitRequestFullscreen();

                // Lock landscape on mobile (async)
                if (isMobileDevice() && screen.orientation?.lock) {
                    try {
                        await screen.orientation.lock('landscape');
                    } catch (err) {
                        console.warn('Orientation lock failed:', err);
                    }
                }
            }
        } catch (err) {
            console.error('Fullscreen error:', err);
            // Revert state if something fails
            setIsFullscreen(false);
        }
    };

    const handleFullscreenExit = async () => {
        // Optimistically update state first
        setIsFullscreen(false);

        try {
            if (document.fullscreenElement || document.webkitFullscreenElement) {
                if (document.exitFullscreen) await document.exitFullscreen();
                else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
            }

            // Unlock orientation back to default
            if (screen.orientation && screen.orientation.unlock) {
                screen.orientation.unlock();
            }
            document.body.style.overflow = '';
        } catch (err) {
            console.error('Error exiting fullscreen:', err);
            // If exit failed, you might want to revert state
            setIsFullscreen(true);
        }
    };


    // const handlePlay = async () => {
    //     if (!videoRef.current) return;

    //     if (isIOS() && videoRef.current.webkitEnterFullscreen) {
    //         // iOS fullscreen (usually landscape automatically)
    //         videoRef.current.webkitEnterFullscreen();
    //     } else if (isMobileDevice()) {
    //         try {
    //             // Android / other mobile: request fullscreen
    //             await handleFullscreenToggle();

    //             // Lock orientation to landscape if supported
    //             if (screen.orientation && screen.orientation.lock) {
    //                 await screen.orientation.lock('landscape');
    //             }
    //         } catch (err) {
    //             console.warn('Fullscreen or orientation error:', err);
    //         }
    //     }
    // };


    // 13 nov 
    const handlePlay = async () => {
        if (!videoRef.current) return;

        if (isIOS()) {
            // 🔥 iOS: use fake fullscreen instead of native Safari player
            setIsFullscreen(true);
            document.body.style.overflow = 'hidden'; // prevent background scroll
        } else if (isMobileDevice()) {
            try {
                // Android / other mobile: request real fullscreen
                await handleFullscreenToggle();

                // Lock orientation to landscape if supported
                if (screen.orientation && screen.orientation.lock) {
                    await screen.orientation.lock('landscape');
                }
            } catch (err) {
                console.warn('Fullscreen or orientation error:', err);
            }
        }
    };

    const isIOS = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    };

    // const handleFullscreenToggle = () => {
    //     if (!document.fullscreenElement) {
    //         // Enter fullscreen
    //         containerRef.current?.requestFullscreen?.();
    //     } else {
    //         // Exit fullscreen
    //         document.exitFullscreen?.();
    //     }
    // };

    useEffect(() => {
        // Check for account_id in localStorage
        const accountId = localStorage.getItem("account_id");
        console.log("Account ID from localStorage:", accountId);

        if (!accountId) {
            console.error("No account_id found in localStorage");
            // You might want to redirect to login or show an error message
            // navigate('/login');
        }

        // Rest of your existing useEffect logic can go here
    }, [navigate]); // Add any other dependencies your effect might need

    // Check user's webinar registration status on component mount
    useEffect(() => {
        if (currentUser && currentUser.webinarStatus === 'registered') {
            setIsWebinarRegistered(true);
        }
    }, [currentUser]); // ✅ run whenever currentUser changes



    // Import the WellnessDisplay component
    const WellnessDisplay = React.lazy(() => import('./WellnessDisplay'));


    // Day of week schedule (0 = Sunday, 1 = Monday, etc.)
    const yogaVideoDaySchedule = {
        0: { title: 'Sunday Relaxation', description: 'Gentle weekend flow' },
        1: { title: 'Monday Energizer', description: 'Start the week strong' },
        2: { title: 'Tuesday Balance', description: 'Find your center' },
        3: { title: 'Wednesday Wellness', description: 'Midweek mindfulness' },
        4: { title: 'Thursday Strength', description: 'Build inner strength' },
        5: { title: 'Friday Flow', description: 'End the week peacefully' },
        6: { title: 'Saturday Stretch', description: 'Weekend rejuvenation' },
    };

    // const getScheduledVideo = () => {
    //     const today = new Date();
    //     // const today = new Date("2025-11-04");
    //     const dateString = today.toISOString().split("T")[0]; // "YYYY-MM-DD"
    //     const dayOfWeek = today.getDay();

    //     // Find the matching video by date prefix
    //     const videoFile = yogaVideos.find((file) => file.startsWith(dateString));

    //     if (!videoFile) return null;

    //     // Extract video title (remove date and extension)
    //     const extractedTitle = videoFile
    //         .replace(/^\d{4}-\d{2}-\d{2}\s*/, "")
    //         .replace(".mp4", "");

    //     // Title/description from day schedule
    //     const daySchedule = yogaVideoDaySchedule[dayOfWeek] || {
    //         title: `Yoga Session for ${dateString}`,
    //         description: `Daily yoga video for ${dateString}`,
    //     };

    //     return {
    //         video: `/videos/${videoFile}`,
    //         title: extractedTitle || daySchedule.title,
    //         description: daySchedule.description,
    //     };
    // };


    // Load scheduled video when component mounts

    const getScheduledVideo = async () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${yyyy}${mm}${dd}`; // → yyyymmdd
        // const formattedDate = 20251205; // → yyyymmdd

        try {
            const response = await getYogaVideoForToday(formattedDate);
            return {
                video: response.track_url,
                title: `Yoga Session - ${formattedDate}`,
                description: `Your scheduled yoga session`,
            };
        } catch (error) {
            console.error("Error fetching today's yoga video:", error);
            return null;
        }
    };

    useEffect(() => {
        const fetchVideo = async () => {
            const data = await getScheduledVideo();
            setScheduledVideo(data);
        };
        fetchVideo();
    }, []);

    // Load campaign progress from localStorage
    useEffect(() => {
        const savedProgress = localStorage.getItem('campaign_progress');
        if (savedProgress) {
            const progress = JSON.parse(savedProgress);
            setCampaignProgress(progress);
        }
    }, []);

    // useEffect(() => {
    //     setScheduledVideo(getScheduledVideo());
    // }, []);

    const getVideoStartTimeOffset = () => {
        const now = new Date();
        const startTime = new Date();
        // startTime.setHours(7, 30, 0, 0); // 7:30 AM
        startTime.setHours(7, 0, 0, 0); // 7:30 AM


        const endTime = new Date();

        endTime.setHours(23, 59, 0, 0); // 8:00 AM

        if (now < startTime) return 0;
        if (now >= endTime) return 0; // For testing: video will play from start
        return (now - startTime) / 1000; // offset in seconds
    };


    const handleServiceClick = (service) => {
        const user = JSON.parse(localStorage.getItem('user'));
        const serviceName = service.serviceType; // 'consult', 'care', or 'converse'

        // Track the CTA click
        trackCTA(`${serviceName}`, user, window.location.pathname);
        console.log(`CTA tracked: ${serviceName}`, user);

        const accountId = localStorage.getItem('account_id');
        console.log('Current account_id:', accountId);


        // if (service.serviceType === 'consult') {
        //     if (accountId === '5') {
        //         setShowContactPopup(true);
        //     } else {
        //         navigate('/consult');
        //     }
        // }

        if (service.serviceType === 'consult') {
            navigate('/consult');
        } else if (service.serviceType === 'care') {
            navigate('/care');
        } else if (service.serviceType === 'converse') {
            navigate('/converse');
        }
    };


    const handleEventAction = (type) => {
        console.log("Button clicked:", type);  // Check if this logs
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        console.log("User from localStorage:", user);  // Verify user data
        trackCTA(type, user, window.location.pathname);

        if (type === 'podcast') {
            return;
        }
        // Add CTA tracking for yoga session join
        if (type === 'yoga') {
            trackCTA('yoga_session_joined', user, '/yoga-video');
        }

        // Your existing yoga logic
        if (type === 'yoga') {
            if (!sessionStartTime) return;
            setIsYogaVideoOpen(true);
        }

        // Handle campaign type
        if (type === 'campaign') {
            setCampaignModalOpen(true);
            return;
        }

        // Handle nurture_within - just track, modal is opened separately
        if (type === 'nurture_within') {
            return;
        }

        // Handle other event types
        setSelectedEvent(type);
        setEventModalOpen(true);
    };

    const handleCloseEventModal = () => {
        setEventModalOpen(false);
        setSelectedEvent(null);
    };

    const handleDailySubmit = async () => {
        if (!dailyAnswer.trim()) return;

        const accountId = localStorage.getItem('account_id');
        if (!accountId || !campaignData) {
            console.error('Account ID or campaign data not available');
            return;
        }

        // Save to database
        const scoreData = {
            user_id: parseInt(user_id),
            campaign_id: campaignData.id,
            day_number: currentDay,
            answer: dailyAnswer
        };

        try {
            const result = await createCampaignUserScore(scoreData);
            if (result.success) {
                console.log('Campaign user score saved successfully:', result.data);

                // Update local state with the new score
                setUserCampaignScores([...userCampaignScores, result.data]);

                // Save the daily answer to progress (for backward compatibility)
                const newProgress = {
                    ...campaignProgress,
                    [`day_${currentDay}`]: {
                        answer: dailyAnswer,
                        timestamp: new Date().toISOString(),
                        completed: true
                    }
                };

                setCampaignProgress(newProgress);

                // Save to localStorage for persistence
                localStorage.setItem('campaign_progress', JSON.stringify(newProgress));

                // Clear the answer
                setDailyAnswer('');

                // Show success message immediately
                setShowSubmissionSuccess(true);

                // After 5 minutes, hide success message and show textarea again
                setTimeout(() => {
                    setShowSubmissionSuccess(false);
                }, 5 * 60 * 1000);

                console.log('Daily answer submitted successfully!');
            } else {
                console.error('Error saving campaign user score:', result.error);
                alert('Failed to submit answer: ' + result.error);
            }
        } catch (error) {
            console.error('Error saving campaign user score:', error);
            alert('Something went wrong. Please try again.');
        }
    };

    // Clear campaign data function
    const handleClearCampaignData = () => {
        // Clear localStorage
        localStorage.removeItem('campaign_progress');

        // Reset state
        setCampaignProgress({});
        setCurrentDay(1);
        setDailyAnswer('');
        setShowSubmissionSuccess(false);

        console.log('Campaign data cleared successfully!');
    };

    // Daily content for the campaign
    const getDailyContent = (day) => {
        const content = {
            1: {
                tip: "Take regular movement breaks. Even 2 minutes of stretching or walking can prevent stiffness and improve circulation.",
                question: "After sitting for hours, maybe working, commuting, or scrolling, you suddenly notice your body feels stiff or heavy. What is one small thing you have done that actually helped your body loosen up?",
                action: "A word, sentence, or a best practice from your own experience."
            },
            2: {
                tip: "Take a 5-minute digital detox. Step away from screens, close your eyes, and focus on your breathing. Notice the sounds around you and how your body feels.",
                question: "You open your laptop or phone and instantly feel overwhelmed by everything you need to do or respond to. What is the one thing that helps you settle your mind and begin?",
                action: "A word, sentence, or a best practice from your own experience."
            },
            3: {
                tip: "Practice progressive muscle relaxation. Tense each muscle group for 5 seconds, then release. Start from your toes and work your way up to your head.",
                question: " After spending time around people in meetings, classes, or even social gatherings, you feel mentally drained. What is the one thing that helps you reset? ",
                action: "A word, sentence, or a best practice from your own experience."
            },
            4: {
                tip: "Write down three things you're grateful for today. Gratitude practice can shift your focus from stress to positive aspects of your life.",
                question: " A passing comment stays with you and keeps coming back to your mind. What is the one thing that helps you process it and feel lighter?",
                action: "A word, sentence, or a best practice from your own experience."
            },
            5: {
                tip: "Go for a 10-minute walk outside. Nature has a calming effect on the nervous system and can help clear your mind.",
                question: " You are in bed, ready to sleep, but your mind keeps replaying conversations or situations from the day. What is the one thing that helps you quiet your thoughts? ",
                action: "A word, sentence, or a best practice from your own experience."
            },
            6: {
                tip: "Practice mindful listening. When someone speaks to you, give them your full attention without planning your response.",
                question: " Nothing major has happened, but you still feel this constant pressure - like you should be doing more or doing better. What is the one thing that helps you ease that stress?",
                action: "A word, sentence, or a best practice from your own experience."
            },
            7: {
                tip: "Try the 5-4-3-2-1 grounding technique: Name 5 things you see, 4 you can touch, 3 you hear, 2 you smell, and 1 you taste.",
                question: "You have sent a message, shared something important, or are waiting on a decision and you keep checking your phone or thinking about it. What is one thing that helps you to not go back to it?",
                action: "A word, sentence, or a best practice from your own experience."
            },
            8: {
                tip: "Create a calming playlist or listen to soothing music. Sound therapy can reduce cortisol levels and promote relaxation.",
                question: " You had your day planned a certain way, and something unexpected throws it off completely. What is the one thing that helps you adjust without feeling thrown off?",
                action: "A word, sentence, or a best practice from your own experience."
            },
            9: {
                tip: "Practice self-compassion. Speak to yourself as you would speak to a good friend who's going through a tough time.",
                question: "There is something you have started but have not finished and it keeps sitting quietly in your mind through the day. What is the one thing that helps you deal with that feeling? ",
                action: "A word, sentence, or a best practice from your own experience."
            },
            10: {
                tip: "Reflect on your journey. Notice how far you've come and the tools you've learned. You're building resilience for life.",
                question: "You are going about your day, and suddenly your mood or energy just drops for no reason. What is the one thing that helps you steady yourself in the moment?",
                action: "A word, sentence, or a best practice from your own experience."
            }
        };

        return content[day] || content[1];
    };

    // Get icon based on day's action
    const getActionIcon = (day) => {
        const icons = {
            1: <HealthAndSafety sx={{ fontSize: 24 }} />, // Writing/Best practice - Health
            2: <Psychology sx={{ fontSize: 24 }} />, // Mindful awareness - Mental health
            3: <Accessibility sx={{ fontSize: 24 }} />, // Body check-in - Physical health
            4: <Favorite sx={{ fontSize: 24 }} />, // Joy/Gratitude - Heart health
            5: <DirectionsWalk sx={{ fontSize: 24 }} />, // Movement/Walk - Physical activity
            6: <People sx={{ fontSize: 24 }} />, // Connections - Social health
            7: <Spa sx={{ fontSize: 24 }} />, // Grounding/Nature - Wellness
            8: <MusicNote sx={{ fontSize: 24 }} />, // Sound healing - Therapy
            9: <SelfImprovement sx={{ fontSize: 24 }} />, // Self-care - Personal health
            10: <EmojiEvents sx={{ fontSize: 24 }} /> // Celebration - Achievement
        };

        return icons[day] || <HealthAndSafety sx={{ fontSize: 24 }} />;
    };

    // Get gradient color based on day's action
    const getActionGradient = (day) => {
        const gradients = {
            1: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', // Writing - Purple
            2: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', // Mindful - Pink
            3: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', // Body - Blue
            4: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', // Joy - Orange/Pink
            5: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', // Movement - Green
            6: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', // Connections - Warm
            7: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', // Grounding - Nature
            8: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', // Sound - Purple
            9: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)w', // Self-care - Pink
            10: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)' // Celebration - Gold
        };

        return gradients[day] || 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)';
    };

    // Get campaign image path based on day
    const getCampaignImage = (day) => {
        return `/campaign/c1d${day}.png`;
    };

    const handleClick = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleDialNow = () => {
        window.location.href = `tel:${phoneNumber}`;
        setOpen(false);
    };

    //yoga terms
    const handleAcceptYogaTerms = async () => {
        try {
            //  Parse user from localStorage (string → object)
            const storedUser = JSON.parse(localStorage.getItem("user"));

            if (!storedUser?.id || !storedUser?.account_id) {
                console.error(" No valid user data found in localStorage");
                return;
            }



            // ✅ Prepare payload for API
            const payload = {
                account_id: storedUser.account_id,
                yoga_terms_conditions: true,
            };

            console.log("📤 Sending payload:", payload);

            //  Send update to backend
            const response = await updateUser(storedUser.id, payload);
            console.log(" Yoga terms updated successfully:", response);
            // ✅ Update the value to true
            storedUser.yoga_terms_conditions = true;

            //  Save updated user back to localStorage
            localStorage.setItem("user", JSON.stringify(storedUser));
            localStorage.setItem("yogaTermsAccepted", "true");

            //  Close modal and open video
            setIsTermsOpen(false);
            setIsYogaVideoOpen(true);
        } catch (error) {
            console.error(" Failed to update yoga terms:", error);
        }
    };

    // Get user info from localStorage
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    const userName = user?.name || "Guest";

    const isExpiredForAccount5 = (() => {
        if (Number(accountId) !== 5) return false;

        // 24 Feb 2026 4:30 PM (local time)
        const cutoff = new Date(2026, 1, 25, 16, 30, 0);
        // Month is 0-indexed → 1 = February

        const now = new Date();

        return now > cutoff;
    })();

    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                minHeight: {
                    xs: 'calc(100vh - 56px)',
                    sm: 'calc(100vh - 64px)',
                    md: 'calc(100vh - 70px)',
                },
            }}
        >
            <Box sx={{
                width: '100%',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 150px)',
                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
            }}>
                {/* Header Row - Welcome Message, Today's Mood, and Action Icons */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    gap: isMobile ? 0 : 3,
                    mb: { xs: 2, sm: 1 },
                    width: '100%'
                }}>
                    <Box sx={{ flex: 1 }}>
                        <WelcomeMessage userName={userName} />
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'stretch' : 'center',
                        gap: isMobile ? 0 : 3,
                        width: isMobile ? '100%' : 'auto',
                        flexShrink: 0
                    }}>
                        {/* <Box sx={{
                            minWidth: isMobile ? '100%' : '280px',
                            maxWidth: isMobile ? '100%' : '320px',
                            order: isMobile ? 1 : 0,
                        }}>
                            <MoodDisplay />
                        </Box> */}
                        {/* Action Icons */}
                        <Box sx={{
                            display: 'flex',
                            gap: isMobile ? 2 : 1.5,
                            justifyContent: isMobile ? 'center' : 'flex-end',
                            order: isMobile ? 2 : 1,
                            flexWrap: 'wrap',
                            pr: { xs: 1, sm: 2 },
                            pl: { xs: 1, sm: 0 }
                        }}>
                            <Tooltip title="Insights" arrow>
                                <IconButton
                                    // onClick={() => setIsInsightsComingSoonOpen(true)}
                                    onClick={() => navigate("/insights")}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(74, 108, 247, 0.1)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(74, 108, 247, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        color: '#fff',
                                    }}
                                >
                                    <InsightsIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="My Appointments" arrow>
                                <IconButton
                                    onClick={() => navigate('/appointments')}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(34, 197, 94, 0.1)',
                                        // color: '#22c55e',
                                        color: '#fff',
                                        '&:hover': {
                                            backgroundColor: 'rgba(34, 197, 94, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',

                                    }}
                                >
                                    <CalendarTodayIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Family Details" arrow>
                                <IconButton
                                    onClick={() => navigate('/family')}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(168, 85, 247, 0.1)',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        // color: '#a855f7',
                                        color: '#fff',
                                        '&:hover': {
                                            backgroundColor: 'rgba(168, 85, 247, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    <FamilyRestroomIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>

                <Box display="flex" gap="20px" sx={{ maxWidth: 1200, mx: 'auto', width: '100%' }}>
                    <Box>
                        <Card
                            sx={{
                                width: '100%',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                '&:hover': {
                                    transform: 'translateX(4px)',
                                    boxShadow: 3,
                                    borderColor: 'primary.main'
                                },
                                borderRadius: 3,
                                border: '1px solid #e0e0e0',
                                p: { xs: 2, sm: 2.5, md: 3 },
                                mb: 1.5,              // reduced margin
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: 1,               // reduced gap
                                textAlign: 'left',
                                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                            }}
                        >
                            <Typography variant="h6" fontWeight={600} sx={{
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}>
                                🎵 AI-Powered Sound Therapy
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Based on your mood and heart rate, echoBuddy designs personalized therapeutic
                                music to elevate your mind and well-being.
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => navigate("/echo-sounds")}
                                sx={{
                                    mt: 0.5,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: "12px",     // ↓ smaller text
                                    px: 1.5,              // ↓ shorter width padding
                                    py: 0.3,              // ↓ shorter height padding
                                    minWidth: "auto",      // removes MUI default 64px width
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',

                                }}
                            >
                                Start Your Journey

                            </Button>

                        </Card>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: { xs: 3, sm: 2, md: 3 },
                            alignItems: 'stretch',
                            width: '100%',
                            minHeight: '290px'
                        }}>
                            {/* Left Column - Service Cards (40% width) */}
                            <Box sx={{
                                flex: isMobile ? '1 1 100%' : '1 1 40%',
                                width: '100%',
                                maxWidth: isMobile ? '100%' : '48%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                '& > *': {
                                    flexShrink: 0
                                }
                            }}>
                                {[
                                    {
                                        icon: careIcon,
                                        title: "Care",
                                        desc: "Your Daily Wellness Companion",
                                        serviceType: "care"
                                    },
                                    {
                                        icon: cultivateIcon,
                                        title: "Converse",
                                        desc: "Feel heard with your buddy",
                                        serviceType: "converse"
                                    },
                                    {
                                        icon: ConsultantIcon,
                                        title: "Consult",
                                        desc: "Book your Appointment",
                                        serviceType: "consult"
                                    }].map((item, idx) => (
                                        <Card
                                            key={idx}
                                            onClick={() => handleServiceClick(item)}
                                            sx={{
                                                width: '100%',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s',
                                                '&:hover': {
                                                    transform: 'translateX(4px)',
                                                    boxShadow: 3,
                                                    borderColor: 'primary.main'
                                                },
                                                borderRadius: 3,
                                                border: '1px solid #e0e0e0',
                                                p: 2,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: 2,
                                                textAlign: 'left',
                                                position: "relative",
                                            }}
                                        >
                                            {item.title === "Care" && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: -2,
                                                        right: 0,
                                                    }}
                                                >
                                                    <Chip
                                                        label="Daily Yoga"
                                                        variant="filled"
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // prevent card click
                                                            navigate("/care", {
                                                                state: { showYoga: true }
                                                            });
                                                        }}
                                                        sx={{
                                                            // backgroundColor: "#4CAF50",
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            color: "#fff",
                                                            fontSize: "14px",
                                                            height: "26px",
                                                            px: 0.5,
                                                            borderRadius: "6px",
                                                            fontWeight: 500,
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor: "#4CAF50", // same as normal
                                                            },
                                                            "&.MuiChip-clickable:hover": {
                                                                backgroundColor: "#4CAF50",
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            <Box sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: '50%',
                                                backgroundColor: 'rgba(106, 115, 168, 0.1)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}>
                                                <img src={item.icon} alt={item.title} style={{ width: 24, height: 24 }} />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    fontWeight={800}
                                                    sx={{
                                                        color: '#6A73A8',
                                                        fontSize: { xs: '14px', sm: '16px' },
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {item.title}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#8A8A8E',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {item.desc}
                                                </Typography>
                                            </Box>

                                            <ArrowForwardIosIcon sx={{
                                                fontSize: { xs: 16, sm: 18 },
                                                color: '#103680',
                                                flexShrink: 0
                                            }} />
                                        </Card>
                                    ))}
                            </Box>

                            {/* Vertical Divider */}
                            {!isMobile && <Divider orientation="vertical" flexItem />}

                            {/* Center Column - Mood & Wellness (30% width) */}
                            <Box sx={{
                                flex: isMobile ? '1 1 100%' : '1 1 30%',
                                width: '100%',
                                maxWidth: { xs: '100%', sm: '100%', md: '48%' },
                                display: 'flex',
                                flexDirection: 'column',
                                gap: { xs: 2, sm: 2.5 },
                                '& > *': {
                                    flexShrink: 0
                                }
                            }}>
                                {/* Daily Wellness Tip - Compact */}
                                <Card sx={{
                                    p: 2.5,
                                    borderRadius: 3,
                                    background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                                    border: '1px solid #bae6fd',
                                    boxShadow: '0 2px 12px rgba(14, 165, 233, 0.08)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 20px rgba(14, 165, 233, 0.15)'
                                    }
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: '8px',
                                            background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 1.5
                                        }}>
                                            <LightbulbIcon sx={{ color: 'white', fontSize: 16 }} />
                                        </Box>
                                        <Typography variant="subtitle2" sx={{ color: '#0c4a6e', fontWeight: 600, fontSize: '0.9rem' }}>
                                            Daily Wellness Tip
                                        </Typography>
                                    </Box>
                                    <Suspense fallback={<div>Loading tip...</div>}>
                                        <WellnessDisplay variant="compact" />
                                    </Suspense>
                                </Card>

                                {/* Quick Actions */}
                                {/* <QuickActions /> */}

                                {/* Wellness Analysis - Compact */}
                                <Card sx={{
                                    p: 0,
                                    borderRadius: 3,
                                    background: '#ffffff',
                                    border: '1px solid #f0f2f5',
                                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)'
                                    }
                                }}>
                                    <CardContent sx={{ p: 2.5 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <Box sx={{
                                                width: 32,
                                                height: 32,
                                                borderRadius: '8px',
                                                backgroundColor: 'rgba(74, 108, 247, 0.1)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 1.5
                                            }}>
                                                <AssessmentIcon sx={{ color: '#4a6cf7', fontSize: 18 }} />
                                            </Box>
                                            <Typography variant="subtitle2" sx={{ color: '#2c3e50', fontWeight: 600, fontSize: '0.9rem' }}>
                                                Wellness Assessment
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" sx={{
                                            color: "text.secondary",

                                            mb: 2,

                                            lineHeight: 1.4,

                                        }}>
                                            Evaluate your overall well-being with our comprehensive assessment                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            onClick={() => {
                                                const user = JSON.parse(localStorage.getItem('user'));
                                                trackCTA('assessment_selection', user, '/assessment-selection');
                                                navigate('/assessment-selection');
                                            }}
                                            sx={{
                                                py: 0.75,
                                                borderRadius: 1.5,
                                                textTransform: 'none',
                                                fontWeight: 500,
                                                fontSize: '0.8rem',
                                                color: '#fff',
                                                borderColor: 'rgba(74, 108, 247, 0.3)',
                                                // backgroundColor: 'rgba(74, 108, 247, 0.05)',
                                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(74, 108, 247, 0.1)',
                                                    borderColor: 'rgba(74, 108, 247, 0.5)'
                                                }
                                            }}
                                        >
                                            Start Assessment
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Box>

                        </Box>



                        {isTablet && (
                            <Box sx={{
                                flex: isTablet ? '1 1 100%' : '1 1 30%',
                                width: '100%',
                                maxWidth: isTablet ? '100%' : '30%',
                                display: 'flex',

                                flexDirection: 'column',
                                gap: { xs: 2, sm: 2.5 },
                                '& > *': {
                                    flexShrink: 0
                                }
                            }}>
                                {/* Events Header */}
                                <Box sx={{
                                    display: 'flex', alignItems: 'center', mb: 2, p: 1.5, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    borderRadius: 2, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', border: '1px solid #e3f2fd', color: '#fff',
                                }}>
                                    <EventAvailableIcon sx={{ color: '#fff', mr: 1, fontSize: 20 }} />
                                    <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600, fontSize: '0.95rem', }}>
                                        Events
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'grid', gap: 1 }}>

                                    {/* NurtureWithin Card - Mobile */}
                                    {/* <Card
                                        elevation={2}
                                        sx={{
                                            width: '100%',
                                            borderRadius: '20px',
                                            overflow: 'hidden',
                                            p: 0,
                                            background: 'transparent',
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: '100%',
                                                background: '#FDE8EF',
                                                borderRadius: '20px',
                                                padding: '1.4rem 1.2rem 1.3rem',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                overflow: 'hidden',
                                                position: 'relative',
                                                fontFamily: 'DM Sans, sans-serif',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box sx={{ position: "absolute", width: 140, height: 140, borderRadius: "50%", background: "#C084FC", top: "-50px", right: "-40px", opacity: 0.2 }} />
                                            <Box sx={{ position: "absolute", width: 100, height: 100, borderRadius: "50%", background: "#1DB48C", bottom: "-30px", left: "-30px", opacity: 0.2 }} />
                                            <Box sx={{ position: "absolute", width: 65, height: 65, borderRadius: "50%", background: "#FB7185", bottom: "40px", right: "-10px", opacity: 0.2 }} />

                                            <Box sx={{ position: "relative", zIndex: 2, width: 60, height: 60, borderRadius: "14px", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", mb: 1, boxShadow: "0 3px 14px rgba(195,68,110,0.12)" }}>
                                                <Box sx={{ position: "absolute", top: -4, right: -4, width: 14, height: 14, borderRadius: "50%", background: "#22C55E", border: "2px solid #FDE8EF" }} />
                                                <img src="/mother child.jpeg" alt="Mother and Child" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }} />
                                            </Box>

                                            <Typography sx={{ fontWeight: 600, color: '#9D3065', fontSize: '9px', letterSpacing: '0.1em', textTransform: 'uppercase', background: '#fff', borderRadius: '20px', px: 2, py: 0.5, mb: 1, zIndex: 2, whiteSpace: 'nowrap', boxShadow: '0 2px 8px rgba(157, 48, 101, 0.08)' }}>
                                                World Maternal Mental Health Day
                                            </Typography>

                                            <Typography sx={{ fontFamily: "DM Serif Display, serif", fontSize: "1.25rem", color: "#7C1D50", lineHeight: 1.15, mb: 0.5, zIndex: 2 }}>
                                                #Nurture<span style={{ fontStyle: "italic", color: "#1DB48C" }}>Within</span>
                                            </Typography>

                                            <Box sx={{ width: 28, height: 2, background: "#1DB48C", borderRadius: "2px", mb: 1, opacity: 0.6, zIndex: 2 }} />

                                            <Typography sx={{ fontSize: '0.75rem', color: "#9D3065", lineHeight: 1.5, maxWidth: 280, opacity: 0.82, mb: 2, zIndex: 2 }}>
                                                {weeklyContent[currentWeek]?.description}
                                            </Typography>

                                           <Button
                                            onClick={() => {
                                                try {
                                                    handleEventAction('nurture_within');
                                                } catch (e) {
                                                    console.error('Error tracking CTA:', e);
                                                }
                                                handleOpenMomModal();
                                            }}
                                            sx={{ background: "#7C1D50", color: "#fff", borderRadius: "10px", px: 2, py: 1, width: 160, fontSize: "12px", fontWeight: 600, fontStyle: "italic", textTransform: "none", boxShadow: "0 4px 14px rgba(124,29,80,0.28)", position: "relative", zIndex: 3, "&:hover": { transform: "translateY(-2px)", boxShadow: "0 6px 20px rgba(124,29,80,0.35)", background: "#7C1D50" } }}
                                        >
                                            Explore Now
                                        </Button>
                                        </Box>
                                    </Card> */}
                                    {/* <SelfCareCampaign onOpenPodcast={() => setIsPodcastOpen(true)} /> */}
                                    <SelfCareCampaign />
                                    <Campaign />
                                        <WellnessCampaign/>

                                    {/* Webinar Event Card */}
                                    <Card
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2.5,
                                            border: '1px solid #E5E7EB',
                                            background: 'linear-gradient(135deg, #f0f7ff 0%, #e1f0ff 100%)',
                                            transition: 'all 0.3s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <Box sx={{
                                                width: 36,
                                                height: 36,
                                                borderRadius: 2,
                                                background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 1.5,
                                                flexShrink: 0,
                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                            }}>
                                                <WebIcon sx={{ color: 'white', fontSize: 18 }} />
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.5, fontSize: '0.9rem' }}>
                                                        {webinarData?.webinar_name || 'Webinar'}
                                                    </Typography>
                                                    <Chip
                                                        label="Webinar"
                                                        size="small"
                                                        sx={{
                                                            height: 18,
                                                            fontSize: '0.6rem',
                                                            fontWeight: 600,
                                                            bgcolor: '#e3f2fd',
                                                            color: '#0d47a1',
                                                            '& .MuiChip-label': { p: '0 6px' },
                                                            borderRadius: 1
                                                        }}
                                                    />
                                                </Box>
                                                <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                    {webinarData?.title || 'No webinars available at the moment.'}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                    {webinarData?.description || 'Stay tuned for upcoming sessions!'}
                                                </Typography>
                                                {webinarData?.webinar_name &&
                                                    webinarData?.title &&
                                                    webinarData?.description && (

                                                        isWebinarRegistered ? (
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <Chip
                                                                    label="Already Registered"
                                                                    size="small"
                                                                    sx={{
                                                                        fontSize: '0.65rem',
                                                                        fontWeight: 600,
                                                                        bgcolor: '#e8f5e8',
                                                                        color: '#2e7d32',
                                                                        '& .MuiChip-label': { px: 1 },
                                                                        borderRadius: 1.5
                                                                    }}
                                                                />
                                                            </Box>
                                                        ) : (
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                disabled={isExpiredForAccount5}
                                                                onClick={() => {
                                                                    if (isExpiredForAccount5) return;

                                                                    const user = JSON.parse(localStorage.getItem('user'));
                                                                    trackCTA('mindful_living', user, window.location.pathname);
                                                                    handleEventAction('webinar');
                                                                }}
                                                                sx={{
                                                                    textTransform: 'none',
                                                                    fontSize: '0.7rem',
                                                                    background: isExpiredForAccount5
                                                                        ? '#cbd5e1'
                                                                        : 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                                    color: 'white',
                                                                    py: 0.5,
                                                                    px: 1.5,
                                                                    borderRadius: 1.5,
                                                                    fontWeight: 500,
                                                                    boxShadow: isExpiredForAccount5
                                                                        ? 'none'
                                                                        : '0 2px 6px rgba(26, 115, 232, 0.2)',
                                                                    '&:hover': {
                                                                        background: isExpiredForAccount5
                                                                            ? '#cbd5e1'
                                                                            : 'linear-gradient(135deg, #1557b0 0%, #0d47a1 100%)'
                                                                    }
                                                                }}
                                                            >
                                                                {isExpiredForAccount5 ? 'Registration Closed' : 'Register Now'}
                                                            </Button>
                                                        ))}
                                            </Box>
                                        </Box>
                                    </Card>

                                    {/* Podcast Card */}
                                    <Card
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2.5,
                                            border: '1px solid #E5E7EB',
                                            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                            transition: 'all 0.3s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <Box sx={{
                                                width: 36,
                                                height: 36,
                                                borderRadius: 2,
                                                background: "#7843f3",
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 1.5,
                                                flexShrink: 0,
                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                            }}>
                                                <HeadphonesIcon sx={{ color: 'white', fontSize: 18 }} />
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle2"
                                                        sx={{
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            WebkitBackgroundClip: 'text',
                                                            WebkitTextFillColor: 'transparent',
                                                            fontWeight: 700, mb: 0.5, fontSize: '0.9rem'
                                                        }}>
                                                        Learn with Echo
                                                    </Typography>
                                                    <Chip
                                                        label="Podcast"
                                                        size="small"
                                                        sx={{
                                                            height: 18,
                                                            fontSize: '0.6rem',
                                                            fontWeight: 600,
                                                            bgcolor: '#7843f3',
                                                            color: '#fff',
                                                            '& .MuiChip-label': { p: '0 6px' },
                                                            borderRadius: 1
                                                        }}
                                                    />
                                                </Box>
                                                <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.75rem', mb: 1 }}>
                                                    Latest Episode •  Available Now
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                    Tune in to our fortnightly podcast series featuring mental health experts, personal stories, and practical tips for wellbeing.
                                                </Typography>
                                                <PodcastListenButton sx={{
                                                        textTransform: 'none',
                                                        fontSize: '0.7rem',
                                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                        color: 'white',
                                                        py: 0.5,
                                                        px: 1.5,
                                                        borderRadius: 1.5,
                                                        fontWeight: 500,
                                                        boxShadow: '0 2px 6px rgba(255, 152, 0, 0.2)',
                                                        '&:hover': {
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                        }
                                                    }} />
                                            </Box>
                                        </Box>
                                    </Card>

                                </Box>
                                <Box>
                                </Box>
                                <Box
                                    onClick={handleClick}
                                    sx={{
                                        position: 'fixed',
                                        bottom: 70,
                                        right: 20,
                                        zIndex: 1000,
                                        cursor: 'pointer',
                                        backgroundColor: '#ff3d47',
                                        color: 'white',
                                        width: 56,
                                        height: 56,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                        '&:hover': {
                                            backgroundColor: '#e0353f',
                                            transform: 'scale(1.1)',
                                            boxShadow: '0 6px 16px rgba(255, 61, 71, 0.3)'
                                        },
                                        transition: 'all 0.2s ease-in-out',
                                        '&::after': {
                                            content: '"24/7"',
                                            position: 'absolute',
                                            top: -8,
                                            right: -8,
                                            backgroundColor: '#4a90e2',
                                            color: 'white',
                                            borderRadius: '10px',
                                            fontSize: '10px',
                                            padding: '2px 6px',
                                            fontWeight: 'bold',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                        }
                                    }}
                                >
                                    <LocalPhoneIcon />
                                </Box>
                            </Box>
                        )}
                    </Box>

                    {/* Vertical Divider */}
                    {!isTablet && <Divider orientation="vertical" flexItem />}

                    <Box sx={{
                        flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 30%' },
                        width: '100%',
                        maxWidth: { xs: '100%', sm: '100%', md: '30%' },
                        display: { xs: 'none', sm: 'none', md: 'flex' },
                        flexDirection: 'column',
                        gap: 0.3,
                        '& > *': {
                            flexShrink: 0
                        }
                    }}>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', mb: 2, p: 1.5, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                            borderRadius: 2, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', border: '1px solid #e3f2fd', color: '#fff',
                        }}>
                            <EventAvailableIcon sx={{ color: '#fff', mr: 1, fontSize: 20 }} />
                            <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600, fontSize: '0.95rem', }}>
                                Events.
                            </Typography>
                        </Box>


                        <Box sx={{ display: 'grid', gap: { xs: 1.5, sm: 2 } }}>

                            {/* New Campaign Style Card */}
                            {/* <Card
                                    elevation={2}
                                    sx={{
                                        width: '100%',                 
                                        minHeight: 220,                
                                        borderRadius: '20px',          
                                        overflow: 'hidden',           
                                        p: 0,  
                                    
                                                               
                                        background: 'transparent',    
                                    }}
                                    >
                                <Box
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    background: '#FDE8EF',
                                    borderRadius: '20px',
                                    padding: '1.4rem 1.2rem 1.3rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    fontFamily: 'DM Sans, sans-serif',
                                    justifyContent: 'center'
                                }}
                                >
                                <Box sx={{
                                    position: "absolute",
                                    width: 140,
                                    height: 140,
                                    borderRadius: "50%",
                                    background: "#C084FC",
                                    top: "-50px",
                                    right: "-40px",
                                    opacity: 0.2
                                }} />
                                <Box sx={{
                                    position: "absolute",
                                    width: 100,
                                    height: 100,
                                    borderRadius: "50%",
                                    background: "#1DB48C",
                                    bottom: "-30px",
                                    left: "-30px",
                                    opacity: 0.2
                                }} />
                                <Box sx={{
                                    position: "absolute",
                                    width: 65,
                                    height: 65,
                                    borderRadius: "50%",
                                    background: "#FB7185",
                                    bottom: "40px",
                                    right: "-10px",
                                    opacity: 0.2
                                }} />

                                <Box
                                    sx={{
                                    position: "relative",
                                    zIndex: 2,
                                    width: 60,
                                    height: 60,
                                    borderRadius: "14px",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mb: 1,
                                    boxShadow: "0 3px 14px rgba(195,68,110,0.12)"
                                    }}
                                >
                                    <Box
                                    sx={{
                                        position: "absolute",
                                        top: -4,
                                        right: -4,
                                        width: 14,
                                        height: 14,
                                        borderRadius: "50%",
                                        background: "#22C55E",
                                        border: "2px solid #FDE8EF",
                                    }}
                                    />

                                    <img
                                        src="/mother child.jpeg"
                                        alt="Mother and Child"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: '10px'
                                        }}
                                    />
                                </Box>

                               <Typography
  sx={{
    fontWeight: 600,
    color: '#9D3065',
    fontSize: '9px',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    background: '#fff',
    borderRadius: '20px',
    px: 2,
    py: 0.5,
    mb: 1,
    zIndex: 2,
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 8px rgba(157, 48, 101, 0.08)',
  }}
>
  World Maternal Mental Health Day
</Typography>

                                <Typography sx={{
                                    fontFamily: "DM Serif Display, serif",
                                    fontSize: "1.25rem",
                                    color: "#7C1D50",
                                    lineHeight: 1.15,
                                    mb: 0.5,
                                    zIndex: 2,
                                }}>
                                    #Nurture<span style={{ fontStyle: "italic", color: "#1DB48C" }}>Within</span>
                                </Typography>

                                <Box sx={{
                                    width: 28,
                                    height: 2,
                                    background: "#1DB48C",
                                    borderRadius: "2px",
                                    mb: 1,
                                    opacity: 0.6,
                                    zIndex: 2,
                                }} />

                                <Typography sx={{
                                   fontSize: { xs: '0.75rem', sm: '0.78rem', md: '0.81rem', lg: '0.84rem', xl: '0.87rem' },
                                    color: "#9D3065",
                                    lineHeight: 1.5,
                                    maxWidth: 280,
                                    opacity: 0.82,
                                    mb: 2,
                                    zIndex: 2,
                                }}>
                                   {weeklyContent[currentWeek]?.description}
                                </Typography>

                                <Button
                                    onClick={() => {
                                        try {
                                            handleEventAction('nurture_within');
                                        } catch (e) {
                                            console.error('Error tracking CTA:', e);
                                        }
                                        handleOpenMomModal();
                                    }}
                                    sx={{
                                    background: "#7C1D50",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    px: 2,
                                    py: 1,
                                    width: 160,
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    fontStyle: "italic",
                                    textTransform: "none",
                                    position: "relative",
                                    zIndex: 3,
                                    boxShadow: "0 4px 14px rgba(124,29,80,0.28)",
                                    "&:hover": {
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 6px 20px rgba(124,29,80,0.35)",
                                        background: "#7C1D50",
                                    },
                                    }}
                                >
                                    Explore Now
                                </Button>
                                </Box>
                            </Card> */}
                            <Campaign />

                            {/* <SelfCareCampaign
                                onOpenPodcast={() => setIsPodcastOpen(true)}
                            /> */}
                            <WellnessCampaign/>
                            <SelfCareCampaign />
                            {campaignData && (
                                <Card

                                // elevation={2}
                                // sx={{
                                //     p: { xs: 2, sm: 2.5, md: 3, lg: 3.5, xl: 4 },
                                //     borderRadius: 2.5,
                                //     border: 'none',
                                //     background: 'linear-gradient(135deg, #8a2be2 0%, #4169e1 100%)',
                                //     position: 'relative',
                                //     overflow: 'hidden',
                                //     transition: 'all 0.3s ease',
                                //     '&:hover': {
                                //         boxShadow: '0 8px 30px rgba(102, 126, 234, 0.3)',
                                //         transform: 'translateY(-2px)'
                                //     }
                                // }}
                                >
                                    {/* Featured Event Badge */}
                                    {/* <Box sx={{
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        px: 1.5,
                                        py: 0.5,
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        color: 'white',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px',
                                        backdropFilter: 'blur(10px)',
                                        zIndex: 2
                                    }}>
                                        Featured Event
                                    </Box> */}

                                    {/* <Box sx={{ display: 'flex', alignItems: 'flex-start', position: 'relative', zIndex: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                                        <Box sx={{
                                            width: { xs: 44, sm: 48, md: 52, lg: 56, xl: 60 },
                                            height: { xs: 44, sm: 48, md: 52, lg: 56, xl: 60 },
                                            borderRadius: '12px',
                                            background: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: { xs: 0, sm: 2, md: 2.5, lg: 2.5, xl: 3 },
                                            mb: { xs: 2, sm: 0 },
                                            flexShrink: 0,
                                            boxShadow: '0 4px 16px rgba(102, 126, 234, 0.2)',
                                            position: 'relative'
                                        }}>
                                            <PsychologyIcon sx={{ color: '#ffff', fontSize: { xs: 24, sm: 26, md: 28, lg: 30, xl: 32 } }} />
                                            <Box sx={{
                                                position: 'absolute',
                                                top: -3,
                                                right: -3,
                                                width: 10,
                                                height: 10,
                                                background: '#22C55E',
                                                borderRadius: '50%',
                                                border: '2px solid white'
                                            }} />
                                        </Box>

                                        <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
                                                <Box>
                                                    <Typography variant="h6" sx={{
                                                        fontWeight: 700,
                                                        color: '#ffffff',
                                                        fontSize: { xs: '1rem', sm: '1.05rem', md: '1.1rem', lg: '1.15rem', xl: '1.2rem' },
                                                        lineHeight: 1.3,
                                                        mb: 0.5
                                                    }}>
                                                        #BeTheChange!
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: { xs: '0.75rem', sm: '0.78rem', md: '0.81rem', lg: '0.84rem', xl: '0.87rem' }, mb: 1 }}>
                                                        Your way of Handling Stress might help someone else
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            
                                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={isEnrolled ? handleContinue : handleCountMeIn}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontSize: { xs: '0.75rem', sm: '0.78rem', md: '0.8rem', lg: '0.82rem', xl: '0.85rem' },
                                                        background: '#ffffff',
                                                        color: '#8a2be2',
                                                        py: { xs: 0.5, sm: 0.6, md: 0.7, lg: 0.75, xl: 0.8 },
                                                        px: { xs: 1.5, sm: 1.8, md: 2, lg: 2.2, xl: 2.5 },
                                                        borderRadius: '8px',
                                                        fontWeight: 600,
                                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                                        '&:hover': {
                                                            background: '#f8f9ff',
                                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                                            transform: 'translateY(-1px)'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    {isEnrolled ? 'Continue' : 'Count Me in'}
                                                </Button>


                                            </Box>
                                        </Box>
                                    </Box> */}
                                </Card>
                            )}

                            {/* Webinar Event Card */}
                            <Card
                                elevation={0}
                                sx={{
                                    p: 2,
                                    borderRadius: 2.5,
                                    border: '1px solid #E5E7EB',
                                    background: 'linear-gradient(135deg, #f0f7ff 0%, #e1f0ff 100%)',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                        transform: 'translateY(-1px)'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Box sx={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: 2,
                                        background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 1.5,
                                        flexShrink: 0,
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}>
                                        <WebIcon sx={{ color: 'white', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.5, fontSize: '0.9rem' }}>
                                                {webinarData?.webinar_name || 'Webinar'}
                                            </Typography>
                                            <Chip
                                                label="Webinar"
                                                size="small"
                                                sx={{
                                                    height: 18,
                                                    fontSize: '0.6rem',
                                                    fontWeight: 600,
                                                    bgcolor: '#e3f2fd',
                                                    color: '#0d47a1',
                                                    '& .MuiChip-label': { p: '0 6px' },
                                                    borderRadius: 1
                                                }}
                                            />
                                        </Box>
                                        <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                            {webinarData?.title || 'No webinars available at the moment.'}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                            {webinarData?.description || 'Stay tuned for upcoming sessions!'}
                                        </Typography>
                                        {webinarData?.webinar_name &&
                                            webinarData?.title &&
                                            webinarData?.description && (

                                                isWebinarRegistered ? (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Chip
                                                            label="Already Registered"
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.65rem',
                                                                fontWeight: 600,
                                                                bgcolor: '#e8f5e8',
                                                                color: '#2e7d32',
                                                                '& .MuiChip-label': { px: 1 },
                                                                borderRadius: 1.5
                                                            }}
                                                        />
                                                    </Box>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        disabled={isExpiredForAccount5}
                                                        onClick={() => {
                                                            if (isExpiredForAccount5) return;

                                                            const user = JSON.parse(localStorage.getItem('user'));
                                                            trackCTA('mindful_living', user, window.location.pathname);
                                                            handleEventAction('webinar');
                                                        }}
                                                        sx={{
                                                            textTransform: 'none',
                                                            fontSize: '0.7rem',
                                                            background: isExpiredForAccount5
                                                                ? '#cbd5e1'
                                                                : 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                            color: 'white',
                                                            py: 0.5,
                                                            px: 1.5,
                                                            borderRadius: 1.5,
                                                            fontWeight: 500,
                                                            boxShadow: isExpiredForAccount5
                                                                ? 'none'
                                                                : '0 2px 6px rgba(26, 115, 232, 0.2)',
                                                            '&:hover': {
                                                                background: isExpiredForAccount5
                                                                    ? '#cbd5e1'
                                                                    : 'linear-gradient(135deg, #1557b0 0%, #0d47a1 100%)'
                                                            }
                                                        }}
                                                    >
                                                        {isExpiredForAccount5 ? 'Registration Closed' : 'Register Now'}
                                                    </Button>
                                                ))}
                                    </Box>
                                </Box>
                            </Card>

                            {/* Podcast Card */}
                            <Card
                                elevation={0}
                                sx={{
                                    p: 2,
                                    borderRadius: 2.5,
                                    border: '1px solid #E5E7EB',
                                    background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                        transform: 'translateY(-1px)'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Box sx={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: 2,
                                        background: "#7843f3",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 1.5,
                                        flexShrink: 0,
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}>
                                        <HeadphonesIcon sx={{ color: 'white', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography variant="subtitle2"
                                                sx={{
                                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    fontWeight: 700, mb: 0.5, fontSize: '0.9rem'
                                                }}>
                                                Learn with Echo
                                            </Typography>
                                            <Chip
                                                label="Podcast"
                                                size="small"
                                                sx={{
                                                    height: 18,
                                                    fontSize: '0.6rem',
                                                    fontWeight: 600,
                                                    bgcolor: '#7843f3',
                                                    color: '#fff',
                                                    '& .MuiChip-label': { p: '0 6px' },
                                                    borderRadius: 1
                                                }}
                                            />
                                        </Box>
                                        <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.75rem', mb: 1 }}>
                                            Latest Episode •  Available Now
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                            Tune in to our fortnightly podcast series featuring mental health experts, personal stories, and practical tips for wellbeing.
                                        </Typography>
                                        <PodcastListenButton
                                            sx={{
                                                textTransform: 'none',
                                                fontSize: '0.7rem',
                                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                color: 'white',
                                                py: 0.5,
                                                px: 1.5,
                                                borderRadius: 1.5,
                                                fontWeight: 500,
                                                boxShadow: '0 2px 6px rgba(255, 152, 0, 0.2)',
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                }
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Card>

                            {/* Yoga Event Card */}
                            {/* <Card
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 2.5,
                                border: '1px solid #C8E6C9',
                                background: 'linear-gradient(135deg, #f1f8e9 0%, #dcedc8 100%)',
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    transform: 'translateY(-1px)'
                                }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <Box sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1.5,
                                    flexShrink: 0,
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <SpaIcon sx={{ color: 'white', fontSize: 18 }} />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1b5e20', mb: 0.5, fontSize: '0.9rem' }}>
                                            Morning Yoga
                                        </Typography>
                                        <Chip
                                            label="Event"
                                            size="small"
                                            sx={{
                                                height: 18,
                                                fontSize: '0.6rem',
                                                fontWeight: 600,
                                                bgcolor: '#e8f5e9',
                                                color: '#2e7d32',
                                                '& .MuiChip-label': { p: '0 6px' },
                                                borderRadius: 1
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.75rem', mb: 1 }}>
                                        {getTomorrow().date} • 7:30 AM • {getTomorrow().duration} • Live Session
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#4B5563', fontSize: '0.7rem', display: 'block', mb: 1, lineHeight: 1.3 }}>
                                        Start your day with gentle yoga to improve flexibility, reduce stress, and enhance mindfulness.
                                    </Typography>
                                    {(() => {
                                        const now = new Date();
                                        const hours = now.getHours();
                                        const minutes = now.getMinutes();
                                        const currentTime = hours * 60 + minutes;
                                        
                                        // Enable from 7:30 AM to 11:59 PM
                                        const startTime = 7 * 60 + 30;  // 7:30 AM in minutes
                                        const endTime = 23 * 60 + 59;   // 11:59 PM in minutes
                                        const isActive = currentTime >= startTime && currentTime <= endTime;

                                        return (
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={() => handleEventAction('yoga')}
                                                disabled={!isActive}
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '0.7rem',
                                                    background: isActive
                                                        ? 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)'
                                                        : 'linear-gradient(135deg, #9E9E9E 0%, #757575 100%)',
                                                    color: 'white',
                                                    py: 0.5,
                                                    px: 1.5,
                                                    borderRadius: 1.5,
                                                    fontWeight: 500,
                                                    boxShadow: '0 2px 6px rgba(76, 175, 80, 0.2)',
                                                    '&:hover': isActive ? {
                                                        background: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)'
                                                    } : {},
                                                    '&.Mui-disabled': {
                                                        background: 'linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)',
                                                        color: '#9e9e9e'
                                                    }
                                                }}
                                            >
                                                {isActive ? 'Join' : 'Join at 7:30 AM'}
                                            </Button>
                                        );
                                    })()}
                                </Box>
                            </Box>
                        </Card> */}
                        </Box>
                        <Box
                            onClick={handleClick}
                            sx={{
                                position: 'fixed',
                                bottom: 70,
                                right: 20,
                                zIndex: 1000,
                                cursor: 'pointer',
                                backgroundColor: '#ff3d47',
                                color: 'white',
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                '&:hover': {
                                    backgroundColor: '#e0353f',
                                    transform: 'scale(1.1)',
                                    boxShadow: '0 6px 16px rgba(255, 61, 71, 0.3)'
                                },
                                transition: 'all 0.2s ease-in-out',
                                '&::after': {
                                    content: '"24/7"',
                                    position: 'absolute',
                                    top: -8,
                                    right: -8,
                                    backgroundColor: '#4a90e2',
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontSize: '10px',
                                    padding: '2px 6px',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }
                            }}
                        >
                            <LocalPhoneIcon />
                        </Box>
                    </Box>

                </Box>

                <PodcastDialog />

                {/* Event Modal for upcoming events */}
                <EventModal
                    open={eventModalOpen}
                    onClose={handleCloseEventModal}
                    eventType={selectedEvent}
                    eventTitle={selectedEvent === 'webinar' ? webinarData?.webinar_name || 'Mindful Living Webinar' : selectedEvent === 'therapy' ? 'Therapy Session' : 'Morning Yoga'}
                    eventIcon={selectedEvent === 'webinar' ? <WebIcon sx={{ color: 'white', fontSize: 20 }} /> : selectedEvent === 'therapy' ? <PsychologyIcon sx={{ color: 'white', fontSize: 20 }} /> : <SpaIcon sx={{ color: 'white', fontSize: 20 }} />}
                    showVideo={selectedEvent === 'yoga'}
                    currentUser={currentUser} setCurrentUser={setCurrentUser}
                />

                {/* Yoga Video Player Dialog */}
                <Dialog
                    open={isYogaVideoOpen}
                    onClose={() => {
                        setIsYogaVideoOpen(false);
                        if (videoRef.current) {
                            videoRef.current.pause();
                            videoRef.current.currentTime = 0;
                        }
                        setIsVideoPlaying(false);
                    }}
                    maxWidth={false} // disable default breakpoints
                    PaperProps={{
                        sx: {
                            backgroundColor: '#000',
                            borderRadius: 2,
                            width: 'fit-content',   // popup shrinks to video width
                            maxWidth: '900px',       // responsive for smaller screens
                            overflow: 'hidden',
                        }
                    }}
                >
                    <DialogTitle sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: '#000',
                        color: 'white',
                        p: 2,
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{
                                width: 36,
                                height: 36,
                                borderRadius: '10px',
                                background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                            }}>
                                <SpaIcon sx={{ color: 'white', fontSize: 18 }} />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    {scheduledVideo?.title || 'Morning Yoga Session'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block' }}>
                                    {scheduledVideo?.description || 'Daily yoga practice'}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton
                            onClick={() => setIsYogaVideoOpen(false)}
                            sx={{ color: 'white' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent sx={{ p: 0, backgroundColor: '#000' }}>
                        {/* <Box
                        ref={containerRef}
                        sx={{
                            position: 'relative',
                            width: 'fit-content',  // shrink to video width
                            height: 'auto',        // adjust height automatically
                            margin: 'auto',
                        }}
                    > */}

                        {/* 13 nov  */}
                        <Box
                            ref={containerRef}
                            sx={{
                                position: isFullscreen ? 'fixed' : 'relative',
                                top: isFullscreen ? 0 : 'auto',
                                left: isFullscreen ? 0 : 'auto',
                                width: isFullscreen ? '100vw' : 'fit-content',
                                height: isFullscreen ? '100vh' : 'auto',
                                backgroundColor: '#000',
                                zIndex: isFullscreen ? 1400 : 'auto',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                                transition: 'all 0.3s ease-in-out',
                                margin: 'auto',
                            }}
                        >


                            {/*   //videoooo */}
                            <Box
                                component="video"
                                ref={videoRef}
                                src={scheduledVideo?.video}
                                autoPlay
                                playsInline
                                x-webkit-airplay="allow"
                                x5-video-player-type="h5"
                                x5-video-orientation="landscape"
                                x5-video-player-fullscreen="true"
                                muted={muted}
                                controls={false}
                                disablePictureInPicture
                                onPlay={handlePlay}
                                onLoadedMetadata={() => {
                                    const offset = getVideoStartTimeOffset();
                                    if (offset !== null && videoRef.current) {
                                        videoRef.current.currentTime = offset;
                                    }
                                }}
                                sx={{
                                    display: 'block',
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: isFullscreen ? '100vh' : 'auto',
                                    objectFit: 'contain',
                                }}
                            />
                            {/* Fullscreen button */}

                            <IconButton
                                onClick={() => handleFullscreenToggle()} // ✅ one unified call
                                sx={{
                                    position: 'absolute',
                                    bottom: 16,
                                    right: 16,
                                    color: 'white',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }}
                            >
                                {isMobileDevice() ? <ScreenRotation /> : <FullscreenIcon />}
                            </IconButton>

                            {/* <IconButton
                            onClick={() => {
                                if (isIOS() && videoRef.current?.webkitEnterFullscreen) {
                                    videoRef.current.webkitEnterFullscreen(); // Keep iOS-specific handling on video
                                } else {
                                    handleFullscreenToggle(); // Use container for standard fullscreen
                                }
                            }}
                            sx={{
                                position: 'absolute',
                                bottom: 16,
                                right: 16,
                                color: 'white',
                                backgroundColor: 'rgba(0,0,0,0.5)',
                            }}
                        >
                            {isMobileDevice() ? <ScreenRotation /> : <FullscreenIcon />}
                        </IconButton> */}


                            {/* Mute/Unmute button */}
                            <IconButton
                                onClick={toggleMute}
                                sx={{
                                    position: 'absolute',
                                    bottom: 16,
                                    right: 64,
                                    color: 'white',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }}
                            >
                                {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                            </IconButton>
                            {isFullscreen && (
                                <IconButton
                                    onClick={() => setIsYogaVideoOpen(false)}
                                    sx={{
                                        position: 'fixed',
                                        top: 16,
                                        right: 16,
                                        color: 'white',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        zIndex: 1400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                        }
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </Box>

                    </DialogContent>
                </Dialog>

                <SmartBiometricTherapyDialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                />

                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        sx: { borderRadius: 3, p: { xs: 0, sm: 2 }, minWidth: { xs: 280, sm: 400 } },
                    }}
                >
                    {/* Warning Icon */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                        <WarningAmberIcon sx={{ color: "#FFA000", fontSize: 48 }} />
                    </Box>

                    {/* Title */}
                    <DialogTitle sx={{ textAlign: "center", mt: { xs: 0, sm: 1 }, fontWeight: 'bold', color: '#1976d2' }}>
                        Mental Health Support
                    </DialogTitle>

                    {/* Content */}
                    <DialogContent>
                        <DialogContentText sx={{ textAlign: "center", fontSize: 16, mb: 3, color: '#424242' }}>
                            In case of emotional distress, mental health crisis or suicidal thoughts, you may reach out to the following 24-Hour helplines:
                        </DialogContentText>
                        
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                            <Box sx={{ 
                                p: 2, 
                                borderRadius: 1, 
                                bgcolor: '#f5f5f5',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5
                            }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                    NIMHANS Helpline
                                </Typography>
                                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: 15 }}>
                                    <a href="tel:08026995435" style={{ color: '#1976d2', textDecoration: 'none' }}>080-26995435</a>
                                </Typography>
                            </Box>

                            <Box sx={{ 
                                p: 2, 
                                borderRadius: 1, 
                                bgcolor: '#f5f5f5',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5
                            }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                    TELEMANAS
                                </Typography>
                                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: 15 }}>
                                    <a href="tel:14416" style={{ color: '#1976d2', textDecoration: 'none' }}>14416</a>
                                    {' or '}
                                    <a href="tel:18008914416" style={{ color: '#1976d2', textDecoration: 'none' }}>1800-891-4416</a>
                                </Typography>
                            </Box>

                            <Box sx={{ 
                                p: 2, 
                                borderRadius: 1, 
                                bgcolor: '#f5f5f5',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5
                            }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                    SAHAI
                                </Typography>
                                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: 15 }}>
                                    <a href="tel:080297777" style={{ color: '#1976d2', textDecoration: 'none' }}>080-297777</a>
                                </Typography>
                            </Box>
                        </Box>
                    </DialogContent>

                    {/* Actions */}
                    <DialogActions sx={{ justifyContent: "center", gap: 2, mb: 2, mt: 2 }}>
                        <Button onClick={handleClose} color="primary" variant="contained" sx={{ px: 4 }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Coming Soon Dialog for Insights */}
                <Dialog
                    open={isInsightsComingSoonOpen}
                    onClose={() => setIsInsightsComingSoonOpen(false)}
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            p: { xs: 2, sm: 3 },
                            minWidth: { xs: 280, sm: 400 },
                            textAlign: 'center'
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <Box
                            sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #4a6cf7 0%, #3b5bdb 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 8px 24px rgba(74, 108, 247, 0.3)'
                            }}
                        >
                            <InsightsIcon sx={{ color: 'white', fontSize: 40 }} />
                        </Box>
                    </Box>

                    <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: '1.5rem', pb: 1 }}>
                        Coming Soon!
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText sx={{ textAlign: 'center', fontSize: '1rem', color: 'text.secondary', mb: 2 }}>
                            We're working hard to bring you personalized insights and analytics.
                        </DialogContentText>
                        <DialogContentText sx={{ textAlign: 'center', fontSize: '0.9rem', color: 'text.secondary' }}>
                            Stay tuned for updates! 🚀
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                        <Button
                            onClick={() => setIsInsightsComingSoonOpen(false)}
                            variant="contained"
                            sx={{
                                px: 4,
                                py: 1,
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #4a6cf7 0%, #3b5bdb 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #3b5bdb 0%, #2f4bbd 100%)'
                                }
                            }}
                        >
                            Got it!
                        </Button>
                    </DialogActions>
                </Dialog>
                <TermsAndConditions
                    open={isTermsOpen}
                    onClose={() => setIsTermsOpen(false)}
                    onAccept={handleAcceptYogaTerms}
                />

                {/* Contact Geetha Popup */}
                {/* <Dialog
                    open={showContactPopup}
                    onClose={handleCloseContactPopup}
                    aria-labelledby="contact-geetha-dialog"
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            p: 3,
                            background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                        }
                    }}
                >
                    <Box sx={{ textAlign: 'center', p: 2 }}>

                        <Typography variant="h5" sx={{ mb: 2, color: '#1a237e', fontWeight: 600 }}>
                            Contact Support
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3, color: '#424242' }}>
                            Please contact Geetha at{' '}
                            <a
                                // href="mailto:geetha@diginxthlt.com" 
                                style={{
                                    color: '#1a73e8',
                                    textDecoration: 'none',
                                    fontWeight: 500
                                }}
                            >
                                @diginxthlt
                            </a>{' '}
                            for assistance with your consultation.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={handleCloseContactPopup}
                            sx={{
                                mt: 2,
                                px: 4,
                                py: 1.5,
                                borderRadius: 2,
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #4a90e2 0%, #1a73e8 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #3a80d2 0%, #0a63c8 100%)',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                }
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog> */}

                {/* Campaign Modal - Professional Design */}
                <Dialog
                    open={campaignModalOpen}
                    onClose={() => setCampaignModalOpen(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            background: '#ffffff',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)',
                            border: '1px solid rgba(102, 126, 234, 0.1)'
                        }
                    }}
                >
                    {/* Professional Modal Header */}
                    <Box sx={{
                        position: 'relative',
                        p: 3,
                        background: 'linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%)',
                        borderBottom: '1px solid rgba(102, 126, 234, 0.1)'
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                                <Box sx={{
                                    width: 54,
                                    height: 54,
                                    borderRadius: '12px',
                                    background: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 4px 16px rgba(102, 126, 234, 0.2)',
                                    position: 'relative'
                                }}>
                                    <PsychologyIcon sx={{ color: 'white', fontSize: 28 }} />
                                    <Box sx={{
                                        position: 'absolute',
                                        top: -2,
                                        right: -2,
                                        width: 12,
                                        height: 12,
                                        background: '#10b981',
                                        borderRadius: '50%',
                                        border: '2px solid white'
                                    }} />
                                </Box>
                                <Box>
                                    <Typography variant="h5" sx={{
                                        fontWeight: 700,
                                        color: '#1e293b',
                                        mb: 0.5,
                                        fontSize: '1.4rem'
                                    }}>
                                        #BeTheChange
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                                        Professional Stress Management Program
                                    </Typography>
                                </Box>
                            </Box>
                            <IconButton
                                onClick={() => setCampaignModalOpen(false)}
                                sx={{
                                    position: 'absolute',
                                    top: 16,
                                    right: 16,
                                    color: '#64748b',
                                    '&:hover': {
                                        color: '#1e293b',
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                    }
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <DialogContent sx={{ p: 3 }}>
                        {/* Campaign Progress Section */}





                        {currentDay <= 10 ? (
                            <>
                                {/* Daily Action Box */}
                                <Card sx={{ mb: 3, p: 2, border: '1px solid #E5E7EB', borderRadius: 2.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                                        <Avatar sx={{
                                            bgcolor: getActionGradient(currentDay),
                                            mr: 2,
                                            width: 48,
                                            height: 48
                                        }}>
                                            {getActionIcon(currentDay)}
                                        </Avatar>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#2f63d3ff', mb: 0.5 }}>
                                                Action Box: Day {currentDay}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#5f6368', mb: 1.5 }}>
                                                {getDailyContent(currentDay).action}
                                            </Typography>

                                            {/* Campaign Image */}
                                            <Box sx={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}>
                                                <Box
                                                    component="img"
                                                    src={getCampaignImage(currentDay)}
                                                    alt={`Campaign Day ${currentDay}`}
                                                    sx={{
                                                        maxWidth: '100%',
                                                        maxHeight: { xs: '25vh', sm: '30vh', md: '35vh', lg: '400px' },
                                                        width: 'auto',
                                                        height: 'auto',
                                                        objectFit: 'contain',
                                                        display: 'block'
                                                    }}
                                                />
                                            </Box>




                                        </Box>
                                    </Box>
                                </Card>

                                {/* Tip of the Day */}
                                <Card sx={{ mb: 3, p: 2, border: '1px solid #E5E7EB', borderRadius: 2.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <Avatar sx={{
                                            bgcolor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            mr: 2,
                                            width: 40,
                                            height: 40
                                        }}>
                                            <LightbulbIcon sx={{ fontSize: 20 }} />
                                        </Avatar>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0d47a1', mb: 0.5 }}>
                                                Tip of the day
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#5f6368', lineHeight: 1.5 }}>
                                                {getDailyContent(currentDay).tip}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Card>

                                {/* Daily Question */}
                                {showSubmissionSuccess ? (
                                    <Card sx={{ p: 2, border: '1px solid #E5E7EB', borderRadius: 2.5 }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0d47a1', mb: 1 }}>
                                            Day {currentDay}: Question
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#5f6368', mb: 2 }}>
                                            {getDailyContent(currentDay).question}
                                        </Typography>

                                        <Box sx={{
                                            p: 2,
                                            bgcolor: '#e8f5e8',
                                            borderRadius: 2,
                                            border: '1px solid #c8e6c9'
                                        }}>
                                            <Typography variant="body2" sx={{ color: '#2e7d32', textAlign: 'center' }}>
                                                Submission successful! Sit back and relax - we'll get back to you soon
                                            </Typography>
                                        </Box>
                                    </Card>
                                ) : !isDayCompleted(currentDay) ? (
                                    <Card sx={{ p: 2, border: '1px solid #E5E7EB', borderRadius: 2.5 }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0d47a1', mb: 1 }}>
                                            Day {currentDay}: Question
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#5f6368', mb: 2 }}>
                                            {getDailyContent(currentDay).question}
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            placeholder="Share your thoughts..."
                                            value={dailyAnswer}
                                            onChange={(e) => setDailyAnswer(e.target.value)}
                                            sx={{
                                                mb: 2,
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: 2,
                                                    '& fieldset': {
                                                        borderColor: '#e0e0e0'
                                                    }
                                                }
                                            }}
                                        />
                                        <Button
                                            variant="contained"
                                            onClick={handleDailySubmit}
                                            disabled={!dailyAnswer.trim()}
                                            sx={{
                                                textTransform: 'none',
                                                background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #1557b0 0%, #0a3d8f 100%)'
                                                },
                                                '&:disabled': {
                                                    background: '#e0e0e0',
                                                    color: '#9e9e9e'
                                                }
                                            }}
                                        >
                                            Submit
                                        </Button>

                                        {showSubmissionSuccess && (
                                            <Box sx={{
                                                mt: 2,
                                                p: 2,
                                                bgcolor: '#e8f5e8',
                                                borderRadius: 2,
                                                border: '1px solid #c8e6c9'
                                            }}>
                                                <Typography variant="body2" sx={{ color: '#2e7d32', textAlign: 'center', mb: 1 }}>
                                                    Submission successful! Sit back and relax - we'll get back to you soon
                                                </Typography>
                                                {currentDay < 10 && (
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => {
                                                            setCurrentDay(currentDay + 1);
                                                            setShowSubmissionSuccess(false);
                                                        }}
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderColor: '#2e7d32',
                                                            color: '#2e7d32',
                                                            '&:hover': {
                                                                borderColor: '#1b5e20',
                                                                bgcolor: '#e8f5e8'
                                                            }
                                                        }}
                                                    >

                                                        Continue to Day {currentDay + 1}
                                                    </Button>
                                                )}
                                            </Box>
                                        )}
                                    </Card>
                                ) : (
                                    <Card sx={{ p: 2, border: '1px solid #E5E7EB', borderRadius: 2.5, bgcolor: '#f8fff8' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#2e7d32', flex: 1 }}>
                                                Day {currentDay}: Completed ✓
                                            </Typography>
                                            <Chip label="Done" color="success" size="small" />
                                        </Box>
                                        <Typography variant="body2" sx={{ color: '#5f6368', mb: 1 }}>
                                            {getDailyContent(currentDay).question}
                                        </Typography>
                                        <Box sx={{ p: 2, bgcolor: '#e8f5e8', borderRadius: 2 }}>
                                            <Typography variant="body2" sx={{ color: '#2e7d32', fontStyle: 'italic' }}>
                                                Your answer: {getDayAnswer(currentDay)}
                                            </Typography>
                                        </Box>
                                    </Card>
                                )}
                            </>
                        ) : (
                            /* Campaign Completion Message */
                            <Card sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2.5, textAlign: 'center', bgcolor: '#f8fff8' }}>
                                <Avatar sx={{
                                    bgcolor: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
                                    mx: 'auto',
                                    mb: 2,
                                    width: 64,
                                    height: 64
                                }}>
                                    <PsychologyIcon sx={{ fontSize: 32 }} />
                                </Avatar>
                                <Typography variant="h6" sx={{ fontWeight: 700, color: '#2e7d32', mb: 1 }}>
                                    You have already completed all days ✓
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#5f6368', mb: 2, lineHeight: 1.6 }}>
                                    Thank you for participating in the #BeTheChange Stress Awareness Campaign!
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#5f6368', mb: 3 }}>
                                    You've successfully submitted responses for all {campaignData?.duration || 10} days.
                                    Keep practicing these stress management techniques in your daily life.
                                </Typography>
                                <Button
                                    variant="contained"
                                    onClick={() => setCampaignModalOpen(false)}
                                    sx={{
                                        textTransform: 'none',
                                        background: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
                                        '&:hover': {
                                            background: 'linear-gradient(135deg, #388e3c 0%, #1b5e20 100%)'
                                        }
                                    }}
                                >
                                    Close
                                </Button>
                            </Card>
                        )}
                    </DialogContent>
                </Dialog>

                {/* Mom & Baby Video Modal */}
                <Dialog
                    open={isMomModalOpen}
                    onClose={handleCloseMomModal}
                    maxWidth="md"
                    fullWidth
                    TransitionProps={{
                        onEntered: () => setPlayerReady(true),
                    }}
                >
                    <Box sx={{ p: 2 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Week {currentWeek} Session
                        </Typography>


                        <Box
                            sx={{
                                position: 'relative',
                                paddingTop: '56.25%',
                                width: '100%',
                                backgroundColor: '#000',
                                borderRadius: 1,
                                overflow: 'hidden',
                            }}
                        >
                            {playerReady && (
                                <iframe
                                    key={videoUrl}
                                    src={`${videoUrl}?autoplay=1&modestbranding=1&rel=0`}
                                    title="Week Session Video"
                                    width="100%"
                                    height="100%"
                                    style={{ position: 'absolute', top: 0, left: 0, border: 'none' }}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            )}
                        </Box>

                        <Button onClick={handleCloseMomModal} sx={{ mt: 2 }}>
                            Close
                        </Button>
                    </Box>
                </Dialog>

            </Box>
        </Box >

    );
};

const HomeWithPodcast = () => (
    <PodcastProvider>
        <Home />
    </PodcastProvider>
);

export default HomeWithPodcast;
